import React from "react";
import logo from "../../../resources/img/logo6.png";
import {NavLink, useNavigate} from "react-router-dom";
import {logoutUser} from "../../../reduxLib/userLib";
import {useDispatch} from "react-redux";

function AdminH() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogout = () => {
        dispatch(logoutUser());
        navigate("/", { replace: true });
    };

    return (
        <div id="admin-layoutM" className="flex min-h-screen">
            <aside className="w-[280px] min-h-screen bg-white border-r shadow-sm">
                <div className="p-6 border-b">
                    <h1 className="text-2xl font-serif font-semibold text-brand-green">
                        <img className="max-w h-[100px]" src={logo}/>
                    </h1>
                    <p className="text-sm text-gray-500 mt-1">Admin Panel</p>
                </div>

                <nav className="p-4 flex flex-col h-[calc(100vh-96px)]">
                    <ul className="space-y-2 flex-1">
                        <li>
                            <NavLink
                                to="/admin/home"
                                className={({ isActive }) =>
                                    `flex items-center px-4 py-3 rounded-lg font-medium ${
                                        isActive
                                            ? "bg-custom-green text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                <i className="fa-solid fa-chart-pie mr-3 w-5"></i>
                                Dashboard
                            </NavLink>
                        </li>

                        <li>
                            <NavLink
                                to="/admin/productsAd"
                                className={({ isActive }) =>
                                    `flex items-center px-4 py-3 rounded-lg ${
                                        isActive
                                            ? "bg-custom-green text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                <i className="fa-solid fa-shopping-bag mr-3 w-5"></i>
                                Products
                            </NavLink>
                        </li>


                        <li>
                            <NavLink
                                to="/admin/categoriesAd"
                                className={({ isActive }) =>
                                    `flex items-center px-4 py-3 rounded-lg ${
                                        isActive
                                            ? "bg-custom-green text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                <i className="fa-solid fa-list mr-3 w-5"></i>
                                Categories
                            </NavLink>
                        </li>

                        <li>
                            <NavLink
                                to="/admin/ordersAd"
                                className={({ isActive }) =>
                                    `flex items-center px-4 py-3 rounded-lg ${
                                        isActive
                                            ? "bg-custom-green text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                <i className="fa-solid fa-shopping-cart mr-3 w-5"></i>
                                Orders
                            </NavLink>
                        </li>

                        <li>
                            <NavLink
                                to="/admin/colorsAd"
                                className={({ isActive }) =>
                                    `flex items-center px-4 py-3 rounded-lg ${
                                        isActive
                                            ? "bg-custom-green text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                <i className="fa-solid fa-pencil mr-3 w-5"></i>
                                Colors
                            </NavLink>
                        </li>

                        <li>
                            <NavLink
                                to="/admin/deliveriesAd"
                                className={({ isActive }) =>
                                    `flex items-center px-4 py-3 rounded-lg ${
                                        isActive
                                            ? "bg-custom-green text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                <i className="fa-solid fa-envelope-open mr-3 w-5"></i>
                                Deliveries
                            </NavLink>
                        </li>

                       {/* <li>
                            <NavLink
                                to="/admin/statistics"
                                className={({ isActive }) =>
                                    `flex items-center px-4 py-3 rounded-lg ${
                                        isActive
                                            ? "bg-custom-green text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                <i className="fa-solid fa-chart-bar mr-3 w-5"></i>
                                Analytics
                            </NavLink>
                        </li>*/}

                        <li>
                            <NavLink
                                to="/admin/settings"
                                className={({ isActive }) =>
                                    `flex items-center px-4 py-3 rounded-lg ${
                                        isActive
                                            ? "bg-custom-green text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                <i className="fa-solid fa-cog mr-3 w-5"></i>
                                Settings
                            </NavLink>
                        </li>
                    </ul>

                    {/* Footer user */}
                    <div className="pt-4 border-t">
                        <div className="flex items-center px-4 py-2">
                            <img
                                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg"
                                alt="Admin"
                                className="w-8 h-8 rounded-full mr-3"
                            />
                            <div className="flex-1">
                                <p className="text-sm font-medium text-gray-800">Maria Admin</p>
                                <p className="text-xs text-gray-500">Administrator</p>
                            </div>
                            <button className="text-gray-400 hover:text-gray-600" onClick={handleLogout}>
                                <i className="fa-solid fa-sign-out-alt"></i>
                            </button>
                        </div>
                    </div>
                </nav>
            </aside>
        </div>
    );
}

export default AdminH;